export default {
  meta: {
    label: 'Français (Canadien)'
  },
  data: {
    'fr-CA': {
      97: ['⚓️', '🦅'],
      98: ['🍌', '👶', '🐝', '👄', ['📫', 'boites aux lettres']],
      99: [
        '🐶',
        '🐱',
        '🐈',
        '🦇',
        '🛶',
        ['🤠', 'cow-boy'],
        '🦌',
        ['🏒', 'bâton  hockey'],
        ['🍦', 'crème glacée'],
        ['🔪', 'couteau'],
        '🔑',
        '🥞'
      ],
      100: [['💃', 'dansant'], '🦃'],
      101: ['👣'],
      102: [['🥅', 'filet de hockey'], '🍟', '👻'],
      103: ['🦍'],
      104: ['🐹', '🌺'],
      105: [],
      106: [['🤹🏼‍♀️', 'Jongleur'], '👖'],
      107: [],
      108: ['🦁', '🦎', '🐆', '🐇', '🦄'],
      109: ['🍈', ['🚶', 'marche']],
      110: ['👃', ['🎶', 'note de musique']],
      111: ['🐙', '👌'],
      112: ['🥞', '🍐', ['🥘', 'pot'], '☂️'],
      113: ['🇶🇦'],
      114: ['🤖', '♻️'],
      115: ['🐍', '🤳', '🥗', '🆙'],
      116: ['🐯', '🌮', '🐅'],
      117: [],
      118: ['🎻', '🏐', ['🌋', 'volcan'], '🌊'],
      119: ['🍉'],
      120: [],
      121: [['💴', 'yen'], '☯️'],
      122: [['⚡️', 'zap']]
    }
  }
};
